import { Status } from './status.enum';
import { Type } from './type.enum';

/**
 * Kenobi parameters for a view
 */
export class KenobiTrackingData {
    /**
     * Page ID for BCO log of statProcess POST request
     * Use the same ID as `RequestOptions.pageId` used for `ErableHttpService`
     */
    public pageId: string;

    /**
     * Contract ID
     * Kenobi param : `cid` (in `globalData` property)
     * @type {string}
     */
    public cid: string;
    /**
     * Kenobi param = `fonctionnalite`
     * @deprecated use functionalities property instead
     * @type {string}
     */
    public functionality: string;
    /**
     * Kenobi param = `fonctionnalite`
     * @type {string[]}
     */
    public functionalities: string[];
    /**
     * Kenobi param : `rubrique`
     * @type {string}
     */
    public section: string;
    /**
     * Kenobi param : `commentaire`
     * @type {string}
     */
    public comment: string;
    /**
     * Kenobi param : `offre`
     * @type {string}
     */
    public offer: string;
    /**
     * Kenobi param : `valeurMonetaire`
     * @type {string}
     */
    public price: string;
    /**
     * Kenobi param : `codeRetour`
     * @type {Status}
     */
    public status: Status;
    /**
     * Route Type
     * @type {Type}
     */
    public type: Type;
    /**
     * Kenobi param : `ligne`
     * @type {string}
     */
    public line: string;
    /**
     * Kenobi param : `typeLigne`
     * @type {string}
     */
    public lineType: string;

    public constructor(functionality: string | string[], section: string, status: Status) {
        this.functionalities = Array.isArray(functionality) ? functionality : [functionality];
        this.section = section;
        this.status = status;
        this.type = Type.CONTRACT;
    }
}
